// removed by extract-text-webpack-plugin
module.exports = {"container":"NoImage-module__container___1_Tpl","image":"NoImage-module__image___24pOx","mobile":"NoImage-module__mobile___3NEpd"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/NoImage.module.scss
// module id = 213
// module chunks = 0 1